import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { BodySmall, BodySmallBold } from 'styles/typography';
import ChatBubbleIcon from 'svg/ChatBubbleIcon';

/** Shown in place of the note list when a clinical assessment has no notes yet. The composer
 * stays visible above it. */
export default function NotesEmptyState({ groupName }: { groupName: string }) {
  return (
    <Container data-testid='notes-empty-state'>
      <ChatBubbleIcon width={40} height={40} />
      <Title>No Notes for {groupName}</Title>
      <Copy>Add context, flag decisions, clinical reasoning, or anything the team should know before admission.</Copy>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 64px 24px;
  text-align: center;
`;

const Title = styled(BodySmallBold)`
  font-size: 14px;
  color: ${colors.black50};
`;

const Copy = styled(BodySmall)`
  max-width: 420px;
  font-size: 13px;
  line-height: 20px;
  color: ${colors.black50};
`;
